import instance from '..'

export const viewAllBlocks = (params) =>
  instance.get(`/api/backend/v1/blocks/view?${params}&status=active`)
